import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'
import useLocations from '@/common/hooks/useLocations/useLocations'

const OriginLocationSelector = ({ value, onChange }) => {
  const { info } = useContext(AppContext)
  const { t } = useTranslation()
  const { locations } = useLocations({ storeId: info?.selectedStore?.id })

  const menuItems = [
    { label: t('Todas las ubicaciones'), value: 'all' },
    ...(locations?.map(l => ({ label: `${l.internal_id} | ${l.internal_name}`, value: l.id })) || []),
  ]

  return (
    <ComboBox
      value={value || 'all'}
      handleChange={event => onChange(event.target.value)}
      label={t('Ubicación de origen')}
      menuItems={menuItems}
      fullWidth
    />
  )
}

export default OriginLocationSelector
